import { render } from "./Memorial.vue?vue&type=template&id=c27fb790&scoped=true"
import script from "./Memorial.vue?vue&type=script&lang=js"
export * from "./Memorial.vue?vue&type=script&lang=js"

import "./Memorial.vue?vue&type=style&index=0&id=c27fb790&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c27fb790"]])

export default __exports__